import React from 'react';

interface Props {
  title: string;
  description?: string;
  action?: React.ReactNode;
}

/** Zelfde patroon als de lokale SectionHeader in pages/WorshipPage.jsx. */
export default function SectionHeader({ title, description, action }: Props) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
        {description && <p className="mt-1 text-slate-500">{description}</p>}
      </div>
      {action}
    </div>
  );
}
